let audioCtx: AudioContext | null = null;
let activeOscillators: OscillatorNode[] = [];
let ringInterval: ReturnType<typeof setInterval> | null = null;

function getCtx(): AudioContext {
  if (!audioCtx) audioCtx = new AudioContext();
  return audioCtx;
}

export function playRingback(): void {
  stopCallAudio();
  const ctx = getCtx();
  const play = () => {
    const gain = ctx.createGain();
    gain.gain.value = 0.15;
    gain.connect(ctx.destination);
    const osc1 = ctx.createOscillator();
    osc1.type = "sine";
    osc1.frequency.value = 440;
    osc1.connect(gain);
    const osc2 = ctx.createOscillator();
    osc2.type = "sine";
    osc2.frequency.value = 480;
    osc2.connect(gain);
    const now = ctx.currentTime;
    osc1.start(now);
    osc2.start(now);
    osc1.stop(now + 2);
    osc2.stop(now + 2);
    activeOscillators.push(osc1, osc2);
  };
  play();
  ringInterval = setInterval(play, 4000);
}

export function playRingtone(): void {
  stopCallAudio();
  const ctx = getCtx();
  const play = () => {
    const gain = ctx.createGain();
    gain.gain.value = 0.2;
    gain.connect(ctx.destination);
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.value = 440;
    osc.connect(gain);
    gain.gain.setValueAtTime(0.2, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.8);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.8);
    activeOscillators.push(osc);
  };
  play();
  ringInterval = setInterval(play, 1500);
}

export function stopCallAudio(): void {
  if (ringInterval) {
    clearInterval(ringInterval);
    ringInterval = null;
  }
  activeOscillators.forEach((o) => {
    try { o.stop(); } catch {}
  });
  activeOscillators = [];
}
